<!-- footer -->
<div class="footer-top section-padding bg-black">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-2 col-sm-4 col-6 mb-sm-20">
        <div class="icon-box">
          <span class="text-light-green"
            ><i class="flaticon-credit-card-1"></i
          ></span>
          <span class="text-custom-white">100% Payment<br />Secured</span>
        </div>
      </div>
      <div class="col-md-2 col-sm-4 col-6 mb-sm-20">
        <div class="icon-box">
          <span class="text-light-green"
            ><i class="flaticon-wallet-1"></i
          ></span>
          <span class="text-custom-white"
            >Support lots<br />
            of Payments</span
          >
        </div>
      </div>
      <div class="col-md-2 col-sm-4 col-6 mb-sm-20">
        <div class="icon-box">
          <span class="text-light-green"><i class="flaticon-help"></i></span>
          <span class="text-custom-white">24 hours / 7 days<br />Support</span>
        </div>
      </div>
      <div class="col-md-2 col-sm-4 col-6">
        <div class="icon-box">
          <span class="text-light-green"><i class="flaticon-heart-1"></i></span>
          <span class="text-custom-white">Calm & Relaxing<br />Atmosphere</span>
        </div>
      </div>
      <div class="col-md-2 col-sm-4 col-6">
        <div class="icon-box">
          <span class="text-light-green"
            ><i class="flaticon-guarantee"></i
          ></span>
          <span class="text-custom-white">Best Price<br />Guaranteed</span>
        </div>
      </div>
      <div class="col-md-2 col-sm-4 col-6">
        <div class="icon-box">
          <span class="text-light-green"
            ><i class="flaticon-app-file-symbol"></i
          ></span>
          <span class="text-custom-white">Mobile Apps<br />Ready</span>
        </div>
      </div>
    </div>
  </div>
</div>
<footer class="section-padding bg-light-theme pt-0 u-line bg-black">
  <div class="u-line instagram-slider swiper-container">
    <ul class="hm-list hm-instagram swiper-wrapper">
      <li class="swiper-slide">
        <a href="#"
          ><img src="assets/img/logo/GalaxyNailsBar.png" alt="GalaxyNailsBar"
        /></a>
      </li>
      <li class="swiper-slide">
        <a href="#"
          ><img src="assets/img/logo/GarySalon.png" alt="GarySalon"
        /></a>
      </li>
      <li class="swiper-slide">
        <a href="#"
          ><img src="assets/img/logo/LucyHairSandbox.png" alt="LucyHairSandbox"
        /></a>
      </li>
      <li class="swiper-slide">
        <a href="#"
          ><img src="assets/img/logo/LUXnailstudio.png" alt="LUXnailstudio"
        /></a>
      </li>
      <li class="swiper-slide">
        <a href="#"
          ><img src="assets/img/logo/MilanNailLounge.png" alt="MilanNailLounge"
        /></a>
      </li>
      <li class="swiper-slide">
        <a href="#"
          ><img
            src="assets/img/logo/NailSocietySalon.png"
            alt="NailSocietySalon"
        /></a>
      </li>
      <li class="swiper-slide">
        <a href="#"><img src="assets/img/logo/NewStar.png" alt="NewStar" /></a>
      </li>
      <li class="swiper-slide">
        <a href="#"><img src="assets/img/logo/OrisVN.png" alt="OrisVN" /></a>
      </li>
      <li class="swiper-slide">
        <a href="#"
          ><img src="assets/img/logo/PalazzoNailBar.png" alt="PalazzoNailBar"
        /></a>
      </li>
      <li class="swiper-slide">
        <a href="#"
          ><img
            src="assets/img/logo/StudioCityTattoo.png"
            alt="StudioCityTattoo"
        /></a>
      </li>
      <li class="swiper-slide">
        <a href="#"
          ><img src="assets/img/logo/TrevorSandbox.png" alt="instagram"
        /></a>
      </li>
    </ul>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl col-lg-4 col-md-4 col-sm-6">
        <div class="footer-contact">
          <h6 class="text-custom-white">Need Help</h6>
          <ul>
            <li class="fw-600">
              <span class="text-light-white">Call Us </span>
              <a href="tel:" class="text-custom-white">+(1) 713-364-3889</a>
            </li>
            <li class="fw-600">
              <span class="text-light-white">Email Us </span>
              <a href="mailto:" class="text-custom-white">contact@jujuja.com</a>
            </li>
            <!-- <li class="fw-600">
              <span class="text-light-white">Join our twitter </span>
              <a href="#" class="text-custom-white">@quickmunch</a>
            </li> -->
            <li class="fw-600">
              <span class="text-light-white">Join our instagram </span>
              <a
                href="https://www.instagram.com/jujuja_us/"
                class="text-custom-white"
                >@jujuja_us</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="col-xl col-lg-4 col-md-4 col-sm-6">
        <div class="footer-links">
          <h6 class="text-custom-white">Download Apps</h6>
          <div class="appimg">
            <a
              href="https://apps.apple.com/us/app/jujuja/id6553972212"
              target="_blank"
              rel="noopener"
            >
              <img
                src="https://framerusercontent.com/images/EMMY1UCV6GVWkqvfNOfXta3sW8.svg?width=144&height=48"
                class="img-fluid"
                alt="app store badge"
              />
            </a>
          </div>

          <div class="appimg">
            <a
              href="https://play.google.com/store/apps/details?id=technology.jk.jujuja"
              target="_blank"
              rel="noopener"
            >
              <img
                src="https://framerusercontent.com/images/ry66Qyyg1zpRs3IhmFE1OeVwdNo.svg?width=144&height=48"
                class="img-fluid"
                alt="google play badge"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="ft-social-media">
          <h6 class="text-center text-light-black">Follow us</h6>
          <ul>
            <li>
              <a href="https://www.facebook.com/JuJuJaApp/"
                ><i class="fab fa-facebook-f"></i
              ></a>
            </li>
            <!-- <li>
              <a href="#"><i class="fab fa-twitter"></i></a>
            </li> -->
            <li>
              <a href="https://www.instagram.com/jujuja_us/"
                ><i class="fab fa-instagram"></i
              ></a>
            </li>
            <!-- <li>
              <a href="#"><i class="fab fa-pinterest-p"></i></a>
            </li> -->
            <li>
              <a href="https://www.youtube.com/@jujuja_us"
                ><i class="fab fa-youtube"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="copyright bg-black">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6">
        <div class="payment-logo mb-md-20 flex items-center">
          <span class="text-light-white fs-14 mr-3">We are accept</span>
          <div class="flex items-center space-x-4">
            <img
              src="assets/img/card/visa.svg"
              alt="#"
              class="payment-icon object-contain"
            />
            <img
              src="assets/img/card/amex.svg"
              alt="#"
              class="payment-icon object-contain"
            />
            <img
              src="assets/img/card/mastercard.png"
              alt="#"
              class="payment-icon object-contain"
            />
          </div>
        </div>
      </div>
      <!-- <div class="col-lg-4 text-center medewithlove align-self-center">
        <a href="https://metropolitanhost.com/" class="text-custom-white"
          >Made with Real <i class="fas fa-heart"></i> Metropolitanthemes</a
        >
      </div> -->
      <div class="col-lg-6">
        <div class="copyright-text">
          <span class="text-light-white"
            >©
            <a href="https://jujuja.com" class="text-light-white"
              >JuJuJa Inc.
            </a>
            - 2025 | All Right Reserved</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
<!-- footer -->
